import { PlayerUpdate } from 'src/models/rotoOffset';

export const updatePlayersRTCValues = async (token: string, updates: PlayerUpdate[]) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/update_rtc_values`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ players: updates })
    });

    const data = await response.json();

    if (response.ok) {
      console.log('RTC values updated successfully:', data);
      return data;
    } else {
      console.error('Failed to update RTC values:', data);
      throw new Error('Failed to update RTC values');
    }
  } catch (error) {
    console.error('Error updating RTC values:', error);
    throw error;
  }
};
